import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MitsIconModule } from 'src/packages/shared-ui';
import { SortButtonsComponent } from './sort-buttons.component';

@NgModule({
  imports: [CommonModule, MitsIconModule],
  declarations: [SortButtonsComponent],
  entryComponents: [SortButtonsComponent],
  exports: [SortButtonsComponent],
  providers: [],
})
export class SortButtonsModule {}
